/* @flow */
import { dispatcher } from 'lib/Dispatcher';
import { reducer, initialState } from 'payments/reducers/Activities';
import { ReduceStore } from 'flux/utils';
import Activities from 'collections/Activities';
import Activity from 'entities/Activity';
import Group from 'entities/Group';
import Transactions from 'collections/Transactions';

class ActivityStore extends ReduceStore {
  getInitialState() {
    return initialState;
  }

  getActivityById(id) {
    return this.getState().activities.get(id);
  }

  getTransactionsForActivityUUID(activityUUID: string): Transactions {
    return this.getState().transactions[activityUUID] || new Transactions();
  }

  getActivityForGroup(group: Group): Activity[] {
    return this.getActivities().filter(activity => {
      return activity.isInGroup(group);
    });
  }

  getOwnedActivities(): Activities {
    return new Activities(this.getActivities().filter(activity => activity.isSender()));
  }

  getUpcomingActivityForGroup(group: Group): Activity[] {
    const today = new Date();

    return this.getActivityForGroup(group).filter(activity => {
      const startAt = activity.getStartAt();
      return startAt && startAt > today;
    });
  }

  getActivities(): Activities {
    return this.getState().activities;
  }

  reduce(state, action) {
    return reducer(state, action);
  }
}

export default new ActivityStore(dispatcher);



// WEBPACK FOOTER //
// ./src/payments/stores/ActivityStore.js